/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_Dialog_TitleInputs */

const en_withdrawal_dialog_title = /** @type {(inputs: Withdrawal_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw from this contract?`)
};

const pl_withdrawal_dialog_title = /** @type {(inputs: Withdrawal_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstąpić od tej umowy?`)
};

/**
* | output |
* | --- |
* | "Withdraw from this contract?" |
*
* @param {Withdrawal_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_dialog_title = /** @type {((inputs?: Withdrawal_Dialog_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Dialog_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_dialog_title(inputs)
	return en_withdrawal_dialog_title(inputs)
});